import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import Moment from 'react-moment';

import React from 'react';
import { NavLink, Link, Route, Switch, withRouter } from 'react-router-dom';

import { BASE_URL, ASSET_URL, i18n, Http } from 'common';

export const Image = (props) => (
  <img {...props} src={ASSET_URL + props.src}  />
);

export const SideBar = () => (
  <nav className="navigation" style={{whiteSpace:"pre"}}>
    <NavLink exact to="/" activeClassName="is-active" ><i className="fa fa-users icon"></i>{i18n('sidebar.manage-clients')}</NavLink>
    <NavLink to="/scopes" activeClassName="is-active"><i className="fa fa-binoculars icon"></i> {i18n('sidebar.system-scopes')}</NavLink>
    <NavLink to="/support" activeClassName="is-active"><i className="fa fa-envelope icon"></i> {i18n('sidebar.system-support')}</NavLink>
  </nav>
);

const NavTitle = ({to, text, ...rest}) => (
  <Route {...rest} path={to}
         children={({match}) => (match? text : null)}/>
)

export class NavBar extends React.Component  {
  onLogout = () => {
    this.refs.form.submit();
  }

  render() {
    const {csrfToken} = this.props;

    return (
      <header className="header">
        <div className="header__logo">
          <Image src="/images/logo_small.png" alt="logo" />
        </div>

        <div className="header__title">
          {this.props.children}
        </div>

        <div className="header__inner">
          <div className="header__infos mr3">
            {this.props.buttons.map(([k, v], index) => (
              <a href={v} key={index}>{k}</a>
            ))}
            <span className="mr1"></span>
            <form ref='form'
                  action={`${BASE_URL}/logout`}
                  method='post'
                  style={{display: 'inline'}}>
              <a className='is-clickable' onClick={this.onLogout}>
                <i className="icon fa fa-power-off mr05" />
                {i18n('navbar.logout')}
              </a>

              <input type='hidden' name='_csrf' value={csrfToken||''} />
            </form>
          </div>
        </div>

      </header>
    )
  }
}


export const Hairline = (props) =>
  (<hr {...props} />)

export const Box = ({children}) =>
  (<div className="box">{children}</div>)

export const BoxContent = ({className, children, ...rest}) =>
  (<div className={classNames("box__content", className)} {...rest}>{children}</div>)

export const Button = ({title, icon, type='action', disabled, style, onClick}) =>
  (<a style={style} className={classNames('btn', 'btn--' + type, 'is-clickable', disabled ? 'btn--disabled' : '')} onClick={onClick}>
      <i className={classNames('fa', 'fa-' + icon)} />&nbsp;&nbsp;{title}
  </a>)

export const ToolButton = ({title, icon, type='action', onClick, className, ...rest}) =>
  (<a {...rest} className={"icon-button is-clickable tooltip-info " + className} onClick={onClick}>
    <i className={classNames('fa', 'fa-' + icon)} />
    <span className="tooltiptext speech-bubble">{title}</span>
  </a>)

export const LinkButton = ({title, url, icon, type='action'}) =>
  (<Link to={url} className={classNames('btn', 'btn--' + type)}><i className={classNames('fa', 'fa-' + icon)} />&nbsp;&nbsp;{title}</Link>)

export const LinkToolButton = ({title, url, icon, className}) =>
  (<Link to={url} className={"icon-button is-clickable tooltip-info " + className}>
    <i className={classNames('fa', 'fa-' + icon)} />
    <span className="tooltiptext speech-bubble">{title}</span>
  </Link>)

export const TagList = ({items = [], store}) =>
  (store.spreadSystemScopes(items)
    .map((i, index) => (<span key={index} className={classNames("tag", "mrb05", {'tag--blue': !i.restricted, 'tag--orange': i.restricted})}><i className={`mr05 icon fa fa-${i.icon}`}></i>{i.value}</span>)))


export const Icon = ({src, className}) =>
  (<i className={classNames(`icon fa fa-${src}`, className)} />)

export const Tag = ({color, children, ...rest}) =>
  (<span {...rest} className={classNames(`tag tag--${color}`, rest.className)}>{children}</span>)

export const Toolbar = ({children}) =>
  (<div className="box__actions">{children}</div>)

export const Footer = ({className, children, ...rest}) =>
  (<footer className={classNames("box__footer", className)} {...rest}>{children}</footer>)



export const Spinner = () => (
  <div className="box loader height-300">
    <div className="loader__state">
      <i className="fa fa-spinner fa-spin loader__stateIcon" />
    </div>
    <div className="box__content loader"></div>
  </div>
)

export const Loader = ({children, trigger}) =>
  ((trigger != null) ? children : <Spinner />)

export const Alert = ({text, error, type="info", icon, onClick, ...rest}) =>
  (<div {...rest} className={`alert alert--${type} mt2 relative`}>
    {text}{type == 'error' && <span><br/>{error}</span>}
    {icon != null &&
      <div className="middle-vertical">
        <i className="icon fa fa-times is-clickable" onClick={onClick} />
      </div>
    }
  </div>)

export const Search = ({placeholder, style, onChange}) => (
  <form style={{display: 'inline-block'}}>
    <input
      type='search'
      placeholder={placeholder}
      onChange={onChange}
      style={style}
    />
  </form>
)

 export const Upload = ({title, icon, onChange}) => (
    <form style={{display: 'inline-block'}}>
        <label htmlFor='import-file'>
            <Button
                title={title}
                icon={icon}
                style={{marginLeft: '5px'}}
            />

            <input
                id='import-file'
                type='file'
                onChange={onChange}
                style={{display: 'none'}}
            />
        </label>
    </form>
 )


export const Counter = ({value}) =>
  (<span className={classNames('label', {'label-important': value==0, 'label-warning': value==null, 'label-info': (value != 0 && value != null)})}>
    {value != null ? value : '?'}
  </span>)

export const FormattedDate = ({children}) =>
  ((children == null) ? <span>Never</span> : <Moment format="DD.MM.YYYY">{children}</Moment>)

export const IconFold = () =>
  (<div>
    <i className="fa fa-caret-right table-row__icon-close"></i>
    <i className="fa fa-caret-down table-row__icon-open"></i>
  </div>)

export const Grid = (props) =>
  (<div className={`grid-${props.columns}`}>{props.children}</div>)

export const Column = ({children, ...rest}) =>
  (<div {...rest}>{children}</div>)


export class Row extends React.Component {
  state = {status: 'close', className: 'table-row-close'}

  onClick = (ev) => {
    const target = ev.target;

    if (target.classList.contains('is-clickable'))
      return;

    const newStatus = (this.state.status === 'close')
      ? 'open' : 'close';

    this.setState({
      status: newStatus,
      className: `table-row-active table-row-${newStatus}`
    });
  }

  render() {
    return (
      <tr className={this.state.className} onClick={this.onClick}>
        {this.props.children}
      </tr>
    );
  }
};
